import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c5ed927"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ReleaseWantToBuy" }
const _hoisted_2 = {
  key: 0,
  class: "distinguish"
}
const _hoisted_3 = { class: "textWarpper" }
const _hoisted_4 = { class: "btnWarpper" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("一键发布")
const _hoisted_6 = { class: "case" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "案例:", -1))
const _hoisted_8 = { class: "caseItem" }
const _hoisted_9 = { class: "user" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "发布单品种采购：", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "求购地径15公分桂花100棵", -1))
const _hoisted_12 = { class: "tips" }
const _hoisted_13 = {
  key: 1,
  class: "form"
}
const _hoisted_14 = { class: "uploadWarpper" }
const _hoisted_15 = { class: "inputWarpper" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = { class: "actions" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanField = _resolveComponent("VanField")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_van_uploader = _resolveComponent("van-uploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.stepActive == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_VanField, {
              rows: "10",
              autosize: "",
              type: "textarea",
              placeholder: $setup.text,
              modelValue: $setup.textValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.textValue) = $event))
            }, null, 8, ["placeholder", "modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_VanButton, {
                type: "primary",
                color: "#FEC64B",
                size: "small",
                onClick: $setup.parseText
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_VanImage, {
                  src: "https://img.yzcdn.cn/vant/cat.jpeg",
                  width: "30",
                  height: "30",
                  fit: "cover",
                  round: ""
                }),
                _hoisted_10
              ]),
              _hoisted_11
            ])
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(`注意事项：（信息越完善越有利于采购方联系您）\n\n信息中请包含以下内容会自动识别: \n1.采购品种\n2.采购数量 \n3.相关规格 4.用苗地点`), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: `item${idx}`
            }, [
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgList, (img, imgIdx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "imgView",
                    key: `img${imgIdx}`
                  }, [
                    _createVNode(_component_VanImage, {
                      src: img.img,
                      width: "72px",
                      height: "72px"
                    }, null, 8, ["src"]),
                    _createVNode(_component_VanIcon, {
                      name: "close",
                      size: "18",
                      onClick: ($event: any) => (_ctx.deleteImg(idx,imgIdx))
                    }, null, 8, ["onClick"])
                  ]))
                }), 128)),
                _createVNode(_component_van_uploader, {
                  class: "upload",
                  accept: "image/*",
                  "max-count": "6",
                  multiple: "",
                  "after-read": $setup.imgAfterRead,
                  onClickUpload: ($event: any) => ($setup.uploadIndex = idx)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VanImage, {
                      src: require("@/assets/img/uploadImage.png")
                    }, null, 8, ["src"])
                  ]),
                  _: 2
                }, 1032, ["onClickUpload"])
              ]),
              _createVNode(_component_VanField, {
                label: "品种",
                readonly: "",
                "is-link": "",
                modelValue: item.name,
                "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                "input-align": "right",
                border: false,
                required: "",
                onClick: ($event: any) => {$setup.isSelectSearch = true;$setup.selectVarietiesIndex = idx}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"]),
              _createVNode(_component_VanField, {
                label: "数量",
                placeholder: "请输入品种",
                border: false,
                "input-align": "right",
                required: ""
              }, {
                input: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      placeholder: "数量",
                      "onUpdate:modelValue": ($event: any) => (($setup.dataList[idx].quantity) = $event)
                    }, null, 8, _hoisted_16), [
                      [_vModelText, $setup.dataList[idx].quantity]
                    ])
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_VanField, {
                label: "地区",
                "is-link": "",
                modelValue: $setup.dataList[idx].receiptAddress || "请选择地址",
                readonly: "",
                required: "",
                border: false,
                "input-align": "right",
                onClick: ($event: any) => {$setup.isShowCityPicker = true;$setup.cityPickerIndex = idx}
              }, null, 8, ["modelValue", "onClick"]),
              _createVNode(_component_VanField, {
                label: "规格",
                "is-link": "",
                modelValue: "请选填写规格",
                border: false,
                "input-align": "right",
                onClick: ($event: any) => {$setup.isSpecificationsShow = true;$setup.specificationsIndex = idx}
              }, null, 8, ["onClick"]),
              _createVNode(_component_VanField, {
                class: "textArea",
                rows: "2",
                autosize: "",
                type: "textarea",
                modelValue: $setup.dataList[idx].profile,
                "onUpdate:modelValue": ($event: any) => (($setup.dataList[idx].profile) = $event),
                placeholder: "请输入备注"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_VanButton, { size: "small" }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }),
                _createVNode(_component_VanButton, {
                  type: "primary",
                  color: "#FEC64B",
                  size: "small",
                  onClick: ($event: any) => ($setup.onsubmit(idx)),
                  disabled: item.isRelease
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.isRelease?'已发布':'发布求购'), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled"])
              ])
            ]))
          }), 128)),
          _createVNode($setup["Specifications"], {
            show: $setup.isSpecificationsShow,
            "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.isSpecificationsShow) = $event)),
            attr: $setup.list[$setup.specificationsIndex].attributeObject,
            onConfirm: $setup.confirmSpecifications
          }, null, 8, ["show", "attr"]),
          _createVNode($setup["CityPicker"], {
            modelValue: $setup.isShowCityPicker,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.isShowCityPicker) = $event)),
            onConfirm: $setup.confirmCity
          }, null, 8, ["modelValue"])
        ])),
    _createVNode($setup["VarietiesSearch"], {
      show: $setup.isSelectSearch,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.isSelectSearch) = $event)),
      onConfirm: $setup.confirmVarieties
    }, null, 8, ["show"])
  ]))
}